import type { ShopGiftCardLine } from '../services/shop';
import { formatMoneyFromCents } from './format-money';

type ShopGiftCardGiftFields = Pick<ShopGiftCardLine, 'recipientEmail' | 'recipientName' | 'message'>;

export function isShopGiftCardGiftLine(line: ShopGiftCardGiftFields): boolean {
  return Boolean(line.recipientEmail?.trim() || line.recipientName?.trim() || line.message?.trim());
}

export function shopGiftCardCartLabel(line: ShopGiftCardLine): string {
  const base = `Gift card — ${formatMoneyFromCents(line.amountCents)}`;
  if (!isShopGiftCardGiftLine(line)) return base;
  const who = line.recipientName?.trim() || line.recipientEmail?.trim();
  return who ? `${base} · Gift for ${who}` : `${base} · Gift`;
}
